/** Only OpenAPI 3.2 gives tag kinds meaning; earlier documents keep their existing groups. */
export const getTagKind = (document, tag) => {
    if (document.openapi.startsWith('3.2.') && (tag?.kind === 'badge' || tag?.kind === 'audience')) {
        return tag.kind;
    }
    return 'nav';
};
